import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { isEmptyString } from "../../../app/shared/helpers";
import { AuthenticationServerService } from "../../core/authentication/authentication-server.service";
import { GoogleOAuthService } from "../../core/oauth/google-oauth.service";

export enum PolicyLevel {
  Weak = 0,
  Medium,
  Strong
}
export interface IPasswordPolicyDto {
  Level: PolicyLevel;
  TestExpressions: string[];
  ForbiddenWords: string[];
}

export class PasswordPolicy {
  constructor(
    public level = PolicyLevel.Weak.toString(),
    public testExpressions: string[] = [],
    public forbiddenWords: string[] = []
  ) { }

  static fromDto(dto: IPasswordPolicyDto): PasswordPolicy {
    return new PasswordPolicy(dto.Level.toString(), dto.TestExpressions, dto.ForbiddenWords);
  }
}

@Injectable()
export class PasswordUpdateService {
  selectedUserName: string = "";

  passwordPolicy: PasswordPolicy = {
    level: "",
    testExpressions: [],
    forbiddenWords: []
  };
  constructor(private router: Router,
    private authenticationServerService: AuthenticationServerService,
    private googleOAuthService: GoogleOAuthService
  ) { }

  canActivatePasswordUpdateScreen(activatedRoute: ActivatedRouteSnapshot): boolean {
    const callbackData = this.googleOAuthService.readCallbackData();
    const userName = callbackData?.loginName || activatedRoute.queryParams["username"];

    if (userName) {
      this.selectedUserName = userName;
      this.authenticationServerService.getPasswordPolicy(userName).subscribe(policy => {
        this.passwordPolicy = PasswordPolicy.fromDto(policy);
      });
      return true;
    }
    if (!isEmptyString(this.selectedUserName)) {
      return true;
    } else {
      this.router.navigate(["/"]);
      return false;
    }
  }
}

export const canActivatePasswordUpdateScreen: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  return inject(PasswordUpdateService).canActivatePasswordUpdateScreen(route);
};

